import { render, staticRenderFns } from "./UndoRedoIcons.vue?vue&type=template&id=e49329a0&scoped=true&"
import script from "./UndoRedoIcons.vue?vue&type=script&lang=ts&"
export * from "./UndoRedoIcons.vue?vue&type=script&lang=ts&"
import style0 from "./UndoRedoIcons.vue?vue&type=style&index=0&id=e49329a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49329a0",
  null
  
)

export default component.exports